import React from "react";
import styles from "./Beds.module.scss";

import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import * as appConfig from "appConfig";
import { messages } from "../Mixing.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

export const Beds: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <div className={styles.container}>
      {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
      <SpatialCarousel showBreadcrumbs controlsPosition="bottom">
        {[
          <div key={1} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.bedsSlideTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.bedsSlideDescription) }}></p>
            </ui.Scrollbars>
          </div>,
          <div key={2} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.bedsSlideTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.bedsSlideDescription2) }}></p>
              <div className={styles.imageContainer}>
                <img className={styles.image} src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/mixing/1.png`} />
              </div>
            </ui.Scrollbars>
          </div>,
        ]}
      </SpatialCarousel>
    </div>
  );
};
